import { UserVuetifyPreset } from 'vuetify';
import { MenuItem, menuItems } from '@/config/menu-items';
import colors, { ColorConfig } from '@/config/colors';
import { sidebarConfig, SidebarConfig } from '@/config/sidebar';
import authentication, { AuthenticationConfig } from './authentication';
import vuetify from './vuetify';

export interface CheeersConfig {
  appTitle: string;
  urlPrefix: string;
  authentication: AuthenticationConfig;
  menuItems: MenuItem[];
  vuetify: Partial<UserVuetifyPreset>;
  colors: ColorConfig;
  sideBar: SidebarConfig;
}

const config: CheeersConfig = {
  urlPrefix: process.env.NODE_ENV === 'production' ? '/user' : undefined,
  appTitle: 'Cheeers',
  authentication,
  vuetify,
  menuItems,
  colors,
  sideBar: sidebarConfig,
};

export default config;
